import React from 'react';
import { number, func, string } from 'prop-types';

export default function NoItems({
    items,
    resetFilters,
    noItemsText,
    noDataMessage,
    noDataButtonText,
    noDataButtonUrl
}) {
    if (items >= 1) return null;

    return (
        <div className="listing-no-results">
            <h5>{noDataMessage}</h5>
            <p>
                <button
                    onClick={resetFilters}
                    className="button button--secondary"
                >
                    {noItemsText}
                </button>
                <a href={noDataButtonUrl} className="button button--secondary">
                    {noDataButtonText}
                </a>
            </p>
        </div>
    );
}

NoItems.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    items: number.isRequired,
    resetFilters: func.isRequired,
    noItemsText: string.isRequired,
    noDataMessage: string.isRequired,
    noDataButtonText: string.isRequired,
    noDataButtonUrl: string.isRequired
    /* eslint-enable react/no-typos */
};
